import axios from "axios";

const STORAGE_KEY = "quotation_queue";

type Quotation = {
  id: string;
  date: string;
  [key: string]: any;
};

function generateId() {
  return Date.now().toString() + "-" + Math.random().toString(36).substr(2, 9);
}

// Obtiene la cola almacenada
export function getQueue(): Quotation[] {
  return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
}

// Guarda la cola
function saveQueue(queue: Quotation[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(queue));
}

// Agrega una nueva cotización a la cola
export function enqueueQuotation(quotation: any) {
  const queue = getQueue();
  queue.push({
    ...quotation,
    id: generateId(),
    date: new Date().toLocaleString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }),
  });
  saveQueue(queue);
}

// Intenta enviar la cola cuando hay internet
export async function flushQueue() {
  if (!navigator.onLine) return;

  let queue = getQueue();
  if (queue.length === 0) return;

  console.log("🔄 Intentando enviar cotizaciones en cola...");

  for (const quotation of [...queue]) {
    try {
      await axios.post(
        "https://vqr3hys2bh.execute-api.us-east-1.amazonaws.com/api/quotaton/send",
        quotation
      );
      console.log("✅ Cotización enviada:", quotation);

      // Eliminar de la cola por ID
      queue = queue.filter((q) => q.id !== quotation.id);
      saveQueue(queue);
    } catch (error) {
      console.error("❌ Error al enviar cotización, se mantiene en cola", error);
      break; // si falla, no sigo con las demás
    }
  }
}
